const NON_VEG_TERMS = ['chicken', 'mutton', 'fish', 'egg', 'prawn', 'prawns', 'shrimp', 'meat'];

export const isVegCustomDish = (value = '') =>
  !NON_VEG_TERMS.some((term) => value.toLowerCase().includes(term));

export function genRefId() {
  const ts = Date.now().toString(36).toUpperCase();
  const rand = Math.random().toString(36).slice(2, 6).toUpperCase();
  return `DGB-${ts}-${rand}`;
}

export function getMinEventDate() {
  const today = new Date();
  const minDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 2);
  const year = minDate.getFullYear();
  const month = String(minDate.getMonth() + 1).padStart(2, '0');
  const day = String(minDate.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function pad2(n) {
  return String(n).padStart(2, '0');
}

/** YYYY-MM-DD → dd/mm/yyyy */
export function isoToDdMmYyyy(iso) {
  if (!iso || typeof iso !== 'string') return '';
  const m = iso.trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return '';
  return `${m[3]}/${m[2]}/${m[1]}`;
}

/** dd/mm/yyyy (or d/m/yyyy) → YYYY-MM-DD, or null if invalid */
export function ddMmYyyyToIso(value) {
  if (!value || typeof value !== 'string') return null;
  const m = value.trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (!m) return null;
  const day = Number(m[1]);
  const month = Number(m[2]);
  const year = Number(m[3]);
  if (!Number.isFinite(day) || !Number.isFinite(month) || !Number.isFinite(year)) return null;
  if (month < 1 || month > 12 || day < 1 || day > 31) return null;
  const dt = new Date(year, month - 1, day);
  if (dt.getFullYear() !== year || dt.getMonth() !== month - 1 || dt.getDate() !== day) return null;
  return `${year}-${pad2(month)}-${pad2(day)}`;
}

/** Normalize typed/pasted date to ISO (accepts YYYY-MM-DD or dd/mm/yyyy). */
export function normalizeEventDateToIso(value) {
  if (!value || typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
    const [y, m, d] = trimmed.split('-').map(Number);
    const dt = new Date(y, m - 1, d);
    if (dt.getFullYear() !== y || dt.getMonth() !== m - 1 || dt.getDate() !== d) return null;
    return trimmed;
  }
  return ddMmYyyyToIso(trimmed);
}

/** YYYY-MM-DD compare — true when date is on/after the earliest allowed event date. */
export function isEventDateAllowed(dateStr) {
  const iso = normalizeEventDateToIso(dateStr);
  if (!iso) return false;
  return iso >= getMinEventDate();
}

export function getEventDateValidationMessage(dateStr) {
  if (!dateStr || !String(dateStr).trim()) return 'Event date is required.';
  const iso = normalizeEventDateToIso(dateStr);
  if (!iso) return 'Enter a valid event date as dd/mm/yyyy.';
  if (!isEventDateAllowed(iso)) {
    return 'Event date must be at least 2 days from today.';
  }
  return null;
}

